import React from 'react'
// ОТКЛЮЧЕНО: локальная система прав до переноса проверок на backend
// import { useDispatch } from 'react-redux'
// import {
//   setUserPermissions,
//   clearUserPermissions,
// } from '../../store/slices/userPermissions'
// import { shouldUseNewPermissions } from '../../utils/devMode'

const PermissionsProvider = ({ children }) => {
  // const dispatch = useDispatch()

  // // Если новая система прав отключена, просто возвращаем children
  // if (!shouldUseNewPermissions()) {
  //   return <>{children}</>
  // }

  // const loadPermissions = () => {
  //   const accData = localStorage.getItem('acc')
  //   if (accData) {
  //     try {
  //       const userData = JSON.parse(accData)
  //       if (userData.role && userData.actions) {
  //         dispatch(setUserPermissions({ role: userData.role, permissions: userData.actions }))
  //       } else if (userData.role) {
  //         dispatch(setUserPermissions({ role: userData.role, permissions: null }))
  //       } else {
  //         dispatch(setUserPermissions({ role: 'viewer', permissions: null }))
  //       }
  //     } catch (error) {
  //       localStorage.removeItem('acc')
  //       dispatch(clearUserPermissions())
  //     }
  //   } else {
  //     dispatch(setUserPermissions({ role: 'viewer', permissions: null }))
  //   }
  // }

  // useEffect(() => {
  //   loadPermissions()
  //   const handleForceUpdate = (event) => {
  //     dispatch(setUserPermissions({
  //       role: event.detail.role,
  //       permissions: event.detail.permissions,
  //     }))
  //   }
  //   window.addEventListener('forceUpdatePermissions', handleForceUpdate)
  //   return () => window.removeEventListener('forceUpdatePermissions', handleForceUpdate)
  // }, [dispatch])

  return <>{children}</>
}

export default PermissionsProvider
